export default "__VITE_ASSET__BQllKIkq__"